import { Identifiable, Project } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { LinkedProject, Linker } from "../linkers/types";

function updateProject(httpClient: HttpClient, linker: Linker) {
  return (project: Identifiable<Project>, nextProject: Project) =>
    httpClient
      .sendHttpRequest<LinkedProject>({
        endpoint: `/projects/${project.uuid}`,
        method: HttpMethods.PATCH,
        data: {
          name: nextProject.name,
          description: nextProject.description,
          ...(project.status.uuid !== nextProject.status.uuid && {
            status: `projectStatuses/${nextProject.status.uuid}`,
          }),
          ...(!!nextProject.attributes && {
            attributes: nextProject.attributes,
          }),
          allocatedResourcesBudget: nextProject.allocatedResourcesBudget,
          allocatedExpensesBudget: nextProject.allocatedExpensesBudget,
        },
      })
      .then(linker.linkProject);
}

export { updateProject };
